
var id = "bhc";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"bhc\">\n<style type=\"text/css\">\n\t#bhc .st0{fill:'';}\n</style>\n<path class=\"st0\" d=\"M11.1,15l48-14.5c1.8-0.6,3.8-0.6,5.6,0l48,14.5c4,1.2,6.8,5,6.8,9.2v52.5c0,24-19.3,40.9-56.4,51l-1.3,0.3\n\tl-1.3-0.3C23.6,117.5,4.3,100.6,4.3,76.6V24.2C4.3,19.9,7,16.2,11.1,15z M13.9,76.6c0,18.5,15.5,32.3,48,41.4\n\tc32.5-9.1,48-23,48-41.4V24.1l-48-14.5l-48,14.5V76.6L13.9,76.6z M40.4,43c5.7-5.7,14.6-6.8,21.5-2.7c8.4-5,19.2-2.2,24.1,6.1\n\tc3.8,6.4,3.2,14.5-1.6,20.3l0.1,0.1L61.9,89.4L39.3,66.8l0.1-0.1C33.5,59.7,34,49.4,40.4,43L40.4,43z M61.9,75.8l15-15l0.2-0.3\n\tc2.8-3.4,2.4-8.4-1-11.3c-2.6-2.2-6.3-2.5-9.2-0.7l-4.9,3l-4.9-3c-3.8-2.3-8.7-1-11,2.8c-1.7,2.9-1.4,6.6,0.7,9.2l0.2,0.3L61.9,75.8\n\tL61.9,75.8z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
